import React from 'react';
import CheckoutForm from './CheckoutForm';
import CheckoutProducts from './CheckoutProducts';
import PaymentMethods from './PaymentMethods';
import CheckoutTopSummary from './CheckoutTopSummary';
import { observer } from 'mobx-react';
import DeliveryOptions from './DeliveryOptions';
import DiscountCode from './DiscountCode';
import Translate from '../Translate/Translate';
import CheckoutBottomSummary from './CheckoutBottomSummary';

const Checkout = () => {
  return (
    <div className="relative max-w-5xl mx-auto my-5" translate="no">
      <h2 className="text-4xl font-axi-bold leading-12 mb-5 lg:my-10">
        <Translate component="checkout" keyword="table-title" />
      </h2>
      <div className="component-checkout__container">
        <div className="lg:mb-12">
          <CheckoutProducts />
        </div>
        <div className="lg:hidden">
          <div className="sticky z-10 top-15 md:top-30">
            <div className="component-checkout__summary">
              <CheckoutTopSummary />
            </div>
            <div className="component-checkout__discountCode">
              <DiscountCode />
            </div>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="lg:max-w-4xl lg:-ml-5">
            <div className="flex mt-7 lg:mt-0">
              <div className="hidden lg:flex flex-col items-center flex-[0_0_280px]">
                <div className="text-2xl font-axi-bold text-center">
                  <Translate component="checkout" keyword="andmed" />
                </div>
                <div className="w-0.5 h-full mr-7 mx-0 my-8 border-l-2 border-l-rgrey-light border-dashed" />
              </div>
              <CheckoutForm />
            </div>
            <div className="flex mt-7 lg:mt-0">
              <div className="hidden lg:flex flex-col items-center flex-[0_0_280px]">
                <div className="text-2xl font-axi-bold text-center">
                  <Translate component="checkout" keyword="my-shipping" />
                </div>
                <div className="w-0.5 h-full mr-7 mx-0 my-8 border-l-2 border-l-rgrey-light border-dashed" />
              </div>
              <DeliveryOptions />
            </div>
            <div className="flex mt-7 lg:mt-0">
              <div className="hidden lg:flex flex-col items-center flex-[0_0_280px]">
                <div className="text-2xl font-axi-bold text-center">
                  <Translate component="checkout" keyword="my-payment" />
                </div>
                <div className="w-0.5 h-full mr-7 mx-0 my-8 border-l-2 border-l-rgrey-light border-dashed" />
              </div>
              <PaymentMethods />
            </div>
            <div className="flex mt-7 lg:mt-0">
              <div className="hidden lg:flex flex-col items-center flex-[0_0_280px]">
                <div className="text-2xl font-axi-bold text-center">
                  <Translate component="checkout" keyword="summary" />
                </div>
                <div className="w-0.5 h-full mr-7 mx-0 my-8 border-l-2 border-l-rgrey-light border-dashed" />
              </div>
              <CheckoutBottomSummary />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(Checkout);
